import { createSelector } from '@reduxjs/toolkit'
import { getResources } from '../../datastore'
import PpeType from '../../datastore/models/PpeType'
import { selectResourcesMemo } from './helpers/selectResourcesMemo'

const selectResources = selectResourcesMemo(['ppeTypes'])
export const selectPpeTypes = createSelector([selectResources], (resources) => {
    return getResources<PpeType>(resources, 'ppeTypes')
})